<template>
	<v-btn
			v-bind="$attrs"
			v-on="$listeners"
			class="rounded-lg tab-btn"
			:class="{ 'tab-btn--active': active }"
			:color="active ? 'secondary' : 'grey darken-2'"
			depressed
			:outlined="active && 3 === 2"
			:style="{ marginRight: margin }"
			:text="!active"
	>
		<slot name="default"/>
	</v-btn>
</template>

<script>
export default {
	inheritAttrs: false,
	name: 'BtnTab',
	props: {
		active: {
			type: Boolean,
			default: false
		},
		margin: {
			type: [Number, String],
			default: 4
		}
	},
	data() {
		return {};
	},
	computed: {},
	methods: {},
	mounted() {
	}
};
</script>

<style lang="scss" scoped>
.tab-btn {

	&--active {
		background: white;
		border-bottom: none;
	}

	& + .tab-btn {
		margin-left: 0.25rem;
	}
}
</style>
